module.exports = __webpack_public_path__ + "static/sport/title-h5.45084bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/title-h5.png
// module id = z4Ct
// module chunks = 0